const buildNewUrl = (url, currentUrl, queryParams, newHashBit) => {
  const encodedQuery = encodeURI(queryParams);
  const [baseUrl, urlHash] = (url || currentUrl).split('#');
  const hashBit = newHashBit || urlHash || '';
  const newUrl = encodedQuery ? `${baseUrl}?${encodedQuery}` : `${baseUrl}`;
  return hashBit ? `${newUrl}#${hashBit}` : newUrl;
};

export default buildNewUrl;
